import request from "@/utils/request.js"

// 账号管理-列表（跨租户）
export const listAdminIgnore = (pageData, formData) => {
    return request.get(`/admin/ignoreTenant/page/${pageData.page}/${pageData.pageSize}/${formData.tenantId}`)
}

// 账号管理-添加（跨租户）
export const addAdminIgnore = (formData) => {
    return request.post(`/admin/ignoreTenant/${formData.tenantId}`, formData)
}

// 账号管理-修改（跨租户）
export const updateAdminIgnore = (updateData) => {
    return request.put(`/admin/ignoreTenant/${updateData.adminId}`, updateData);
};

// 账号管理--删除用户（跨租户）
export const deleteAdminIgnore = (adminId) => {
    return request.delete(`/admin/ignoreTenant/${adminId}`);
};

// 账号管理-微信解绑（跨租户）
export const unBindAdminIgnore = (adminId) => {
    return request.put(`/admin/ignoreTenant/unbindWechat/${adminId}`);
};

// 账号管理-用户详情（跨租户）
export const detailAdminIgnore = (id) => {
    return request.get(`/admin/ignoreTenant/${id}`)
}
